import { Injectable } from '@angular/core';

import { Timestamp, collection, doc, setDoc, count, sum, average, getAggregateFromServer, getFirestore, deleteDoc, getDocs, where, query, documentId, getDoc, updateDoc, getDocFromCache, addDoc, orderBy, increment } from "firebase/firestore";
import moment from 'moment';
import { BehaviorSubject, Observable, defer, from, switchMap } from 'rxjs';
import { ownedCollection, withCurrentOwner } from '../../../utils/firestore-ownership';


@Injectable({
  providedIn: 'root'
})
export class DividendsService {

  private dividends!: BehaviorSubject<any[]>;

  constructor() {
    this.dividends = new BehaviorSubject<any[]>([])
  }

  public async selectAll(): Promise<void> {
    // console.log('DividendsService', 'selectAll')

    const dividends:any[] = []

    const q = ownedCollection('Dividends');
    const allDocs = await getDocs(q)
    allDocs.docs.forEach((d:any, j:any, h:any) => {
      // console.log('Doc:', d.id, 'Side:', d.data().side, j, h)
      
      const doc = { ...d.data(), id: d.id }
      dividends.push(doc)
    })

    this.dividends.next(dividends)
  }

  getAll(): Observable<any[]> {
    console.log('DividendsService', 'getAll')

    return defer(() => from(this.selectAll()).pipe(switchMap(() => this.dividends.asObservable())));
  }

  async addItem(e:any):Promise<void> {
    console.log('DividendsService', 'addItem', e)

    await addDoc(collection(getFirestore(), 'Dividends'), { ...withCurrentOwner(e), created_on: Timestamp.now(), modified_on: Timestamp.now() });
    // this.dividends.next([e, ...this.dividends.value])
    await this.selectAll()
  }

  async delete(e:any):Promise<void>{
    console.log('DividendsService', 'delete', e.id)

    await deleteDoc(doc(getFirestore(), 'Dividends', e.id));
    await this.selectAll();
  }

  async modify(e:any):Promise<void>{
    console.log('DividendsService', 'modify', e.id)

    await updateDoc(doc(getFirestore(), 'Dividends', e.id), { ...withCurrentOwner(e), modified_on: Timestamp.now() });
    await this.selectAll();
  }

}
